import api from './api';
import { authService } from './authService';

export const taskService = {
  // Tüm görevleri getir
  getTasks: async () => {
    try {
      const restaurantId = authService.getCurrentRestaurantId();
      const response = await api.get(`/api/business/tasks?restaurant=${restaurantId}`);
      return response.data.tasks || [];
    } catch (error) {
      console.error('Görevler getirilirken hata:', error);
      return []; // Hata durumunda boş dizi döndür
    }
  },

  // Yeni görev oluştur
  createTask: async (taskData) => {
    try {
      const response = await api.post('/api/business/tasks', taskData);
      return response.data.task || {};
    } catch (error) {
      console.error('Görev oluşturulurken hata:', error);
      throw error;
    }
  },

  // Görev güncelle
  updateTask: async (taskId, updateData) => {
    try {
      const response = await api.patch(`/api/business/tasks/${taskId}`, updateData);
      return response.data.task || {};
    } catch (error) {
      console.error('Görev güncellenirken hata:', error);
      throw error;
    }
  },

  // Görev sil
  deleteTask: async (taskId) => {
    try {
      const response = await api.delete(`/api/business/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      console.error('Görev silinirken hata:', error);
      throw error;
    }
  },
  
  // Görev istatistiklerini getir
  getTaskStats: async () => {
    try {
      const restaurantId = authService.getCurrentRestaurantId();
      const response = await api.get(`/api/business/tasks/stats?restaurant=${restaurantId}`);
      return response.data || {
        total: 0,
        completed: 0,
        pending: 0,
        completionRate: 0,
        averageCompletionTime: 0
      };
    } catch (error) {
      console.error('Görev istatistikleri getirilirken hata:', error);
      return {
        total: 0,
        completed: 0,
        pending: 0,
        completionRate: 0,
        averageCompletionTime: 0
      };
    }
  },
  
  // Görev öncelik dağılımını getir
  getTaskPriorityDistribution: async () => {
    try {
      const restaurantId = authService.getCurrentRestaurantId();
      const response = await api.get(`/api/business/tasks/priority-distribution?restaurant=${restaurantId}`);
      return response.data || { high: 0, medium: 0, low: 0 };
    } catch (error) {
      console.error('Görev öncelik dağılımı getirilirken hata:', error);
      return { high: 0, medium: 0, low: 0 };
    }
  },
  
  // Hareketsiz görevleri getir (15+ gün aksiyon alınmamış)
  getInactiveTasks: async (days = 15) => {
    try {
      const restaurantId = authService.getCurrentRestaurantId();
      const response = await api.get(`/api/business/tasks/inactive?restaurant=${restaurantId}&days=${days}`);
      return response.data || [];
    } catch (error) {
      console.error('Hareketsiz görevler getirilirken hata:', error);
      return [];
    }
  }
}; 